import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { SeasonLink as Link } from "../../components/Seasons/SeasonLink";
import avatarPlaceholder from '../../assets/icons/avatar.svg';
import { getSharedProfile } from '../../api/profile';
import { buildDisplayName } from '../../utils/userDisplay';
import { getRoleLabel, participatesInRating } from '../../utils/roles';
import { buildContactLink } from '../../utils/contactLinks';
import telegramIcon from '../../assets/icons/contacts/telegram.svg';
import vkIcon from '../../assets/icons/contacts/vk.svg';
import maxIcon from '../../assets/icons/contacts/max.svg';
import styles from './sharedProfile.module.css';

export function SharedProfilePage() {
  const { token } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function load() {
      setLoading(true);
      setError('');
      try {
        const response = await getSharedProfile(token);
        setProfile(response);
      } catch (err) {
        setError(err.message || 'Ссылка недействительна или истекла.');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [token]);

  if (loading) return <div className={styles.page}><p>Загружаем профиль...</p></div>;
  if (error) return <div className={styles.page}><p className={styles.error}>{error}</p></div>;
  if (!profile) return <div className={styles.page}><p>Профиль не найден.</p></div>;

  const emailLink = buildContactLink('email', profile.email);
  const telegramLink = buildContactLink('telegram', profile.telegram);
  const vkLink = buildContactLink('vk', profile.vk);
  const maxLink = buildContactLink('max', profile.max_contact);
  const websiteLink = buildContactLink('website', profile.website);
  const contactItems = [
    emailLink ? { key: 'email', label: 'Email', icon: null, link: emailLink } : null,
    telegramLink ? { key: 'telegram', label: 'Telegram', icon: telegramIcon, link: telegramLink } : null,
    vkLink ? { key: 'vk', label: 'VK', icon: vkIcon, link: vkLink } : null,
    maxLink ? { key: 'max', label: 'MAX', icon: maxIcon, link: maxLink } : null,
    websiteLink ? { key: 'website', label: 'Сайт', icon: null, link: websiteLink } : null,
  ].filter(Boolean);

  return (
    <div className={styles.page}>
      <div className={styles.bgGlow} />
      <div className={styles.bgGlowSecondary} />
      <article className={styles.card}>
        <div className={styles.badge}>Публичный профиль</div>
        <img
          src={profile.avatar_url || avatarPlaceholder}
          alt=""
          className={styles.avatar}
          onError={(event) => {
            event.currentTarget.src = avatarPlaceholder;
          }}
        />
        <h1 className={styles.title}>{buildDisplayName(profile)}</h1>
        <p className={styles.login}>@{profile.login}</p>
        <div className={styles.meta}>
          <span>Статус на платформе: {getRoleLabel(profile.role)}</span>
          {participatesInRating(profile.role) && profile.rank_position ? <span>Место #{profile.rank_position}</span> : null}
        </div>
        <p className={styles.caption}>
          Это профиль участника SFEDU PRO. Чтобы взаимодействовать с командами и кейсами,
          авторизуйся на платформе.
        </p>
        {profile.show_contacts && contactItems.length ? (
          <div className={styles.contacts}>
            {contactItems.map((item) => (
              <a
                key={item.key}
                className={styles.contactLink}
                href={item.link.href}
                target={item.key === 'email' ? undefined : '_blank'}
                rel={item.key === 'email' ? undefined : 'noreferrer'}
              >
                {item.icon ? <img src={item.icon} alt="" /> : null}
                <span>{item.label}</span>
              </a>
            ))}
          </div>
        ) : null}
        <Link className={styles.cta} to="/register">
          Присоединиться к платформе
        </Link>
        <Link className={styles.secondaryCta} to="/login">
          Уже есть аккаунт? Войти
        </Link>
      </article>
    </div>
  );
}
